import React, {useEffect, useState} from "react";
import axios from "axios";
import {keepChk} from "../../../static/js/Common";
import ShopStopPopupV2 from "./ShopStopPopupV2";
import { BACK_OFFICE_API } from "constants/apiUrls";

const ShopSelectBoxV2 = React.memo((props) => {

  // 파라미터 값 가져오기
  const getShopId = new URLSearchParams(window.location.search).get("shopSelect");

  // 세션 정보 조회
  const getKeepChk = keepChk();
  const userId = Number(getKeepChk[0].userId)
  const userType = Number(getKeepChk[0].userType)

  // 정보
  const [shopList, setShopList] = useState([]);
  const [shopId, setShopId] = useState();
  const [shopName, setShopName] = useState();
  let changeShopId = props.setShopId;
  let changeShopList = props.setShopList;
  let changeLoginId = props.setLoginId;

  let url = props.url

  useEffect(() => {
    function handleClickOutside(e) {
      let select = document.getElementById("shopSelect");

      if(select) {
        select.classList.remove("active");
      }


      if(e.target.classList.contains("shopSelectText")) {
        select.classList.add("active");
      }
    }

    document.addEventListener("click", handleClickOutside)

    const fetchData = async () => {
      /*let getShopList = await axios.get(`${orderApiUrl}/shop/detail/admin/${userId}`);
      let shopData = getShopList.data;
      let shopListData = [{
        id: shopData.id,
        storeName: shopData.name,
        serviceType: shopData.serviceType,
        status: shopData.status,
        loginId: shopData.loginId,
        approvalTpcd1: shopData.approvalType1,
        approvalTpcd2: shopData.approvalType2
      }]

      setShopList(shopListData)

      shopSetting(shopListData);*/

      try {
        if(userType === 1) {
          let shopList = await axios.get(`${BACK_OFFICE_API}/shop/downShopList`, {
            params: {
              chanlTpcd: 2,
              topShopId: userId
            }
          })

          setShopList(shopList.data);
          if(changeShopList !== undefined) {
            changeShopList(shopList.data);
          }


          shopSetting(shopList.data);
        } else {
          let shopInfo = await  axios.get(`${BACK_OFFICE_API}/shop/${userId}`);

          let shopData = shopInfo.data;
          let shopList = [];

          shopData.forEach((value) => {
            shopList.push({
              id: value.id,
              storeName: value.shopName,
              serviceType: value.serviceTpcd,
              status: value.statusTpcd,
              loginId: value.loginId,
              createTs: value.createTs,
              approvalTpcd1: value.approvalTpcd1,
              approvalTpcd2: value.approvalTpcd2
            });
          });

          console.log(shopList);
          setShopList(shopList);
          if(changeShopList !== undefined) {
            changeShopList(shopList);
          }

          shopSetting(shopList);
        }
      } catch(error) {
        console.log(error)
      }
    }
    fetchData();

    const shopSetting = (shopList) => {
      if(getShopId === null) {
        setShopId(shopList[0].id);
        setShopName(shopList[0].storeName);

        if(changeShopId !== undefined) {
          changeShopId(shopList[0].id)
        }
        if(changeLoginId !== undefined) {
          changeLoginId(shopList[0].loginId);
        }

      } else {
        for(let i = 0; shopList.length > i; i++) {
          if(Number(getShopId) === shopList[i].id) {
            setShopId(shopList[i].id);
            setShopName(shopList[i].storeName);

            if(changeShopId !== undefined) {
              changeShopId(shopList[i].id)
            }
            if(changeLoginId !== undefined) {
              changeLoginId(shopList[i].loginId);
            }
          }
        }
      }
    }
  }, [userId, getShopId])

  const selectOptionEvent = (id) => {
    window.location.href = `${url}?shopSelect=${ id }`
  }

  let shopSelectList = shopList.map((value, index) => {
    return (
      <li
        className="selectoption" data-id={value.id} key={index}
        onClick={() => selectOptionEvent(value.id)}
      >
        {value.storeName}
      </li>
    )
  })

  return (
    <>
      <div id='shopSelect' className='shopSelect select'>
        <div
          id="shopSelectText"
          className='shopSelectText selectText'
          data-id={shopId}
        >
          {shopName}
        </div>
        <ul className='shopSelectOptionList'>
          {shopSelectList}
        </ul>
      </div>
      <ShopStopPopupV2 shopList={shopList} />
    </>
  )
});

export default ShopSelectBoxV2;